export const RESET = 'EXCMUSERDATAWORKPLACE_UPDATE_RESET'
export const SET_ERROR = 'EXCMUSERDATAWORKPLACE_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXCMUSERDATAWORKPLACE_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXCMUSERDATAWORKPLACE_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXCMUSERDATAWORKPLACE_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXCMUSERDATAWORKPLACE_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXCMUSERDATAWORKPLACE_UPDATE_UPDATE_RETRIEVED'
